import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Sparkles, CreditCard, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Sanfte Upgrade-Karte statt eines leeren Fehler-Screens, wenn ein
 * Standardversion-Nutzer eine Vollversion-Funktion (z. B. Steuer-Tool)
 * öffnet. Zeigt Feature-Name, Nutzen und direkten Checkout-Button.
 */
export default function UpgradeCard({ feature = "Diese Funktion", benefit, testid = "upgrade-card" }) {
  const [busy, setBusy] = useState(null);

  const startCheckout = async (lookupKey) => {
    setBusy(lookupKey);
    try {
      const r = await axios.post(`${API}/api/billing/checkout`,
        { lookup_key: lookupKey, origin_url: window.location.origin },
        { withCredentials: true });
      window.location.href = r.data.checkout_url;
    } catch (e) {
      toast.error("Checkout konnte nicht gestartet werden", {
        description: e?.response?.data?.detail || "Bitte erneut versuchen.",
      });
      setBusy(null);
    }
  };

  return (
    <div className="card-surface p-8 md:p-12 text-center max-w-2xl mx-auto" data-testid={testid}>
      <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-primary/15 border border-primary/40 mb-5">
        <Lock className="h-6 w-6 text-primary" strokeWidth={1.5} />
      </div>
      <h2 className="font-heading text-2xl md:text-3xl tracking-tight" data-testid={`${testid}-title`}>
        {feature} ist Teil der Vollversion
      </h2>
      <p className="mt-4 text-muted-foreground max-w-lg mx-auto leading-relaxed" data-testid={`${testid}-body`}>
        {benefit || "Schalte alle Funktionen frei — inklusive Steuer-Tool, unbegrenzten Trades und Strategien sowie vollem KI-Coach."}
      </p>

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Button
          className="rounded-full h-12 px-6"
          onClick={() => startCheckout("trademind_monthly")}
          disabled={busy !== null}
          data-testid={`${testid}-monthly`}
        >
          {busy === "trademind_monthly" ? (
            <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Wird geöffnet…</>
          ) : (
            <><CreditCard className="mr-2 h-4 w-4" strokeWidth={1.5} /> 8,99 € / Monat freischalten</>
          )}
        </Button>
        <Button
          variant="outline"
          className="rounded-full h-12 px-6"
          onClick={() => startCheckout("trademind_yearly")}
          disabled={busy !== null}
          data-testid={`${testid}-yearly`}
        >
          {busy === "trademind_yearly" ? (
            <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Wird geöffnet…</>
          ) : (
            <><Sparkles className="mr-2 h-4 w-4" strokeWidth={1.5} /> 84,99 € / Jahr — über 2 Monate sparen</>
          )}
        </Button>
      </div>
      <p className="text-xs text-muted-foreground mt-6">
        Monatlich kündbar · Bezahlung sicher über Stripe · Rechnung wird per E-Mail zugestellt
      </p>
    </div>
  );
}
